import Vue from "vue/dist/vue";
import VueRouter from "vue-router";
import VueApp from "./App";
import router from "./utilities/router";
import "./utilities/ccquery.js"
import * as CCDb from "./utilities/db";
import { authReady } from "./utilities/firebase";
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import { messages } from './i18n/index.js'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
var language = navigator?.languages[0] || navigator.language || navigator.userLanguage;
window.isMetric = language.includes("-US")
$('html').attr('lang', language)
var i18n = new VueI18n({
  locale: language,
  messages,
  fallbackLocale: 'en-US',
})

Vue.use(VueRouter);
Vue.config.productionTip = true;

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

window.VueInstance = new Vue({
  i18n,
  router,
  el: "#app",
  components: { VueApp },
  render: h => h(VueApp),
  data() {
    return this.originalValue();
  },
  methods: {
    originalValue() {
      return {
        chores: {},
        choreRef: false,
        parent: null,
        kids: [],
        locked: true,
        loading: false,
        canNotConnectToServer: false,
        showNavbar: true,
        selectedChild: 0
      };
    },
    handleSuccess: null,
    // MARK: Load Chores
    async initLoadChores() {
      let _this = this;
      await authReady;
      // An anonymous session belongs to a child device that is pairing, it
      // cannot read any family data.
      if (!CCDb.currentUser()) {
        this.$data.kids = [];
        return;
      }
      const profile = await CCDb.getUserProfile();
      $('html').attr('theme', (profile && profile.get('theme')) || 'vib-cools')
      await CCDb.getParent().then(async parent => {
        this.$data.parent = parent;
        this.$data.chores = [];
        _this.$data.parent = parent;
        const kids = await CCDb.getKids(parent.id);
        _this.$data.kids = kids;
        await _this.loadChores()
        try {
          let kidNames = ''
          kids.forEach(kid => kidNames = kidNames + kid.get('name') + ',')
          kidNames = kidNames.substr(0, kidNames.length - 1)
          if (typeof webkit !== "undefined" && webkit.messageHandlers) {
            if (kids.length !== 0)
              webkit.messageHandlers.callback.postMessage(`childInfo|${kidNames || 'Error With Name'}`);
          } else {
          }
        } catch { }
        try {
          profile.set('lastLogin', Date.now())
          await profile.save()
        } catch{ }
      }).catch(e => this.serverHasIssue(e))
    },
    serverHasIssue(e) {
      console.error(e)
      const fatal = [
        "unavailable",
        "internal-error",
        "permission-denied",
        "unauthenticated",
        "failed-precondition"
      ];
      if (!fatal.includes(e && e.code)) return;
      this.$data.canNotConnectToServer = true;
      this.$data.kids = [{
        name: "Unable to connect to server",
        get(a) {
          return this[a]
        }
      }]
    },
    async loadChores() {
      let _this = this;
      if (_this.$data.kids.length == 0) {
        if (this.$route.path !== '/kids/new') {
          this.$router.push('/kids/new').catch(() => { });
        }
        return
      }
      // An index loop, not for...in: index.html adds a random() helper to
      // Array.prototype, and for...in walks the prototype chain.
      for (let i = 0; i < _this.$data.kids.length; i++) {
        const chores = await CCDb.getChores(_this.$data.kids[i].id);
        _this.$data.chores[i] = chores || [];
        if (VueInstance.$children[0]) {
          VueInstance.$children[0].$children.forEach(x => x.$forceUpdate());
        }
      }
    }
  }
});

